export enum ECODE_REDEEM_STATUS {
  FAILED = 'failed',
  SUCCESS = 'success',
  ACTIVATE = 'activate'
}

export enum TrackEventType {
  VIEW = 'view',
  CLICK = 'click'
}

export enum LoyaltyEvent {
  PRO_POINT_ESTIMATE = 'PROPointEstimate',
  REWARDS_CENTER_ACTIVATE = 'clickBtnLoyaltyActivateReward'
}

export enum LoyaltySource {
  BASKET_PRO_POINTS_PROMOTIONS = 'BasketProPointsPromotions'
}

export type LoyaltyGraphQLErrorWithExtensions = {
  message?: string;
  extensions?: {
    code?: string;
    error?: {
      message?: string;
      statusCode?: number;
      th: string;
      en: string;
    };
  };
};
